module.exports = __webpack_public_path__ + "img/verificar-cuenta-icon.b4818dcf.png";